import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import shortid from "shortid";
import { Sessao } from "../../../helpers/Token";
import S from "./styles";
import S2 from "../styles";
import {
  simplesNacional,
  lucroRealPresumido,
  gerenciadorPropostas,
  arquivado,
  pessoasFisicas,
  planilhasCalculo,
  // eMultiplicador
} from "./values";

import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import ModalVerbasComunicado from "./ModalVerbasComunicado";

import { Container, Flipper } from "../../../components/CardFlip";
import { useSelector } from "react-redux";

import iconPessoasFisicas from "../../../assets/icons/icon-oportunidades-pessoas-fisicas.white.svg";
import iconPlanilhaCalculo from "../../../assets/icons/icon-planilhas-white.svg";
import ModalPlanilhaDiesel from "./ModalPlanilhaDiesel";
import ModalPlanilhaIrPensaoAlimenticia from "./ModalPlanilhaIrPensaoAlimenticia";
import ModalSubvencoes from "./ModalSubvencoes";
import ModalVideoRevisor from "./ModalVideoRevisor";
import ModalRevisorBloqueio from "./ModalRevisorBloqueio";
import ModalTerceirosInformativo from "./ModalTerceiros/Informativo";
import ModalTerceirosVideo from "./ModalTerceiros/Video";

const urlImage = "https://images.e-auditoria.com.br/erecuperador/bemvindo";

function Welcome() {
  const history = useHistory();
  const planoMaster = Sessao("planoMaster");
  const planoTeste = Sessao("planoTeste");

  const isDevelopment = () =>
    ["development", "testing"].includes(process.env.REACT_APP_AMBIENTE);

  const [options, setOptions] = useState({});
  const [header, setHeader] = useState({});
  const terceirosReducer = useSelector((state) => state.terceiros);

  const renderOptions = () => {
    let { pathname } = history.location;
    pathname = pathname.split("/").pop();
    if (
      pathname === "lucro-real-presumido" &&
      planoMaster === false &&
      planoTeste === false
    ) {
      // REC-217 - Incluindo validação de teste
      history.push("/bemvindo");
    }
    switch (pathname) {
      case "simples-nacional":
        setOptions(simplesNacional);
        setHeader({
          title: "oportunidades para empresas optantes pelo simples nacional",
          icon: `${urlImage}/simples-nacional/padrao-interna.svg`,
        });
        break;
      case "arquivado":
        setOptions(arquivado);
        setHeader({
          title: "arquivo",
          icon: `${urlImage}/simples-nacional/padrao-interna.svg`,
        });
        break;
      case "lucro-real-presumido":
        setOptions(lucroRealPresumido);
        setHeader({
          title:
            "oportunidades para empresas optantes pelo lucro real e presumido",
          icon: `${urlImage}/lucro-real/padrao-interna.svg`,
        });

        break;
      case "oportunidades-pessoas-fisicas":
        setOptions(pessoasFisicas);
        setHeader({
          title: "oportunidades para pessoas físicas",
          icon: iconPessoasFisicas,
        });
        break;
      case "e-planilhas":
        setOptions(planilhasCalculo);
        setHeader({
          title: "e-planilhas",
          icon: iconPlanilhaCalculo,
        });
        break;
      case "gerenciador-propostas-contratos":
        setOptions(gerenciadorPropostas);
        setHeader({
          title: "gerenciador de propostas e contratos",
          icon: `${urlImage}/gerenciador/padrao-interna.svg`,
        });

        break;
      // case "multiplicador":
      //   setOptions([...eMultiplicador]);
      //   setHeader({
      //     title: "e-Multiplicador",
      //     icon: `${urlImage}/multiplicador/e-mult-icon-rec.svg`,
      //   });

      //   break;
      default:
        setOptions({});
        break;
    }
  };

  const isArquivado = () => window.location.pathname === "/bemvindo/arquivado";

  const initialRender = useCallback(() => {
    renderOptions();

    if (localStorage.getItem("eRecuperadorAceito") === "false") {
      history.push("/contrato");
    }

    sessionStorage.removeItem("icmsModule");
  }, []);

  useEffect(() => {
    initialRender();
  }, [history.location]);

  useEffect(() => {
    if (terceirosReducer.redirect)
      window.location = process.env.REACT_APP_CONTRIBUICOES_TERCEIROS_URL;
  }, [terceirosReducer]);

  return (
    <>
      {options?.label == "lucroRealPresumido" ? <ModalVerbasComunicado /> : null}
      <ModalSubvencoes />
      <ModalTerceirosInformativo />
      <ModalTerceirosVideo />
      <ModalPlanilhaDiesel />
      <ModalPlanilhaIrPensaoAlimenticia />
      <ModalVideoRevisor />
      <ModalRevisorBloqueio />
      <Header />

      <S.InternalHeader>
        <div className="d-flex align-items-center">
          <S.InternalHeader.Icon src={header.icon} />
          <S.InternalHeader.Title>{header.title}</S.InternalHeader.Title>
        </div>
        <S.InternalHeader.ButtonBack
          type="link"
          size="large"
          icon="rollback"
          onClick={() => history.push("/bemvindo")}
        >
          Voltar
        </S.InternalHeader.ButtonBack>
      </S.InternalHeader>

      <S.WelcomeInternal>
        <S.InternalHeader.Description>
          {isArquivado() && (
            <h6>
              Nesta área disponibilizamos ferramentas para cálculo de teses
              tributárias cuja jurisprudência acabou se tornando desfavorável ao
              contribuinte.
            </h6>
          )}
        </S.InternalHeader.Description>
        <S2.MainContainer>
          <Container {...{ [options.label]: true }}>
            {options?.modulos?.slice(0, 4).map((item) => (
              <Flipper
                key={shortid.generate()}
                internal
                beta={item.beta}
                planilha={item.planilha}
                icon={item.icon}
                title={item.title}
                description={item.description}
                onClick={() => item.onClick()}
              />
            ))}
          </Container>
        </S2.MainContainer>
        <S2.MainContainer2>
          <Container>
            {options?.modulos?.slice(4, options?.modulos?.length).map((item) => (
              <Flipper
                key={shortid.generate()}
                internal
                beta={item.beta}
                planilha={item.planilha}
                icon={item.icon}
                title={item.title}
                description={item.description}
                onClick={() => item.onClick()}
              />
            ))}
          </Container>
        </S2.MainContainer2>
      </S.WelcomeInternal>

      <Footer />
    </>
  );
}

export default Welcome;
